/* eslint-disable */
import * as __three_vrm__ from '.';
// @ts-ignore
Object.assign(THREE, __three_vrm__);
